import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/navlayer/update/navlayer.update.mutation.gql"
import type {
  NavLayerUpdateMutation,
  NavLayerUpdateMutationVariables,
} from "@/v2-backoffice-client/navlayer/update/__types__/navlayer.update.mutation"

type Options = MutationHookOptions<
  NavLayerUpdateMutation,
  NavLayerUpdateMutationVariables
>

export function useNavLayerUpdateMutation(options?: Options) {
  return useMutation<NavLayerUpdateMutation, NavLayerUpdateMutationVariables>(
    mutation,
    options,
  )
}
